import { setupAdalClient } from '@cannon-design/piral-adal';


export const client = setupAdalClient({
    clientId: 'ec4ba285-43a4-44b7-89e1-25d6a75ef725',
    // clientId: "81564df8-5329-4fce-bf3a-824da49010b9",
  
    authority: 'https://login.microsoftonline.com/2a628329-47c2-4e25-a873-a847f2961371',
    redirectUri:  window.location.origin, // 'http://localhost:3000/auth-callback',
    // postLogoutRedirectUri: 'http://localhost:3000/',
    cacheLocation: 'localStorage',
    protocolMode: 'OIDC', // 'ADAL' | 'OIDC'
    scopes: ['openid', 'profile', 'email', 'offline_access',], // "https://analysis.windows.net/powerbi/api/.default"],
} as any);

export function account() {
    return client.account();
  }
export function getUserRoles() {
    return (client.account()?.idToken as any).roles || [];
}
  // Helper to decode JWT
function parseJwt(token: string) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}